<template>
    <el-container class="layout_container">
        <!-- 主要区域 -->
        <div class="layout_main">
            <router-view class="layout_main_page" v-if="!$route.meta.keepAlive"></router-view>
            <keep-alive>
                <router-view class="avue-view" v-if="$route.meta.keepAlive" />
            </keep-alive>
        </div>

        <!-- loading -->
        <loading v-if="$store.state.loading" />
    </el-container>
</template>

<script>
import loading from './components/loading.vue'
export default {
    name: 'layout',
    components: {
        loading
    },
    data () {
        return {

        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.layout_container {
    width: 100%;
    height: 100%;
    .layout_main {
        width: 100%;
        height: 100%;
        overflow-y: hidden;
        background: #f3f3f3;
        &_page {
            width: 100%;
            height: 100%;
            background: #f3f3f3;
            box-sizing: border-box;
            overflow: hidden;
        }
    }
}

.layout_menu {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
}
</style>
